import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import {
  CrudMasterDetailView,
  CrudContext,
  GridView,
  MasterDetailForm,
  Widget,
  FormatText,
  FormNumber,
  FormInput,
  FormDatePicker,
  FormSubmitButton,
  Button,
  FormTextArea,
} from '@digital/ui';

import {
  createCrfPlanilhaOrcamento,
  getAllCrfPlanilhasOrcadoEconomicoAnoMes,
  updateCrfPlanilhaOrcadoEconomicoAnoMes
} from '@app/api/crf/crfProjeto';

import {
  exportaCrfModelo,
  exportarCrfPlanilhaOrcadoEconomicoAnoMes
} from '@app/api/crf/crfExportaFile';

import UploadFile from '@app/components/uploadFile';
import { hasPermission } from '@app/helpers/permissions';
import CrfPlanilhaOrcadoEconomicoAnoMesTabela from './CrfPlanilhaOrcadoEconomicoAnoMesTabela';
import { EExportarModeloCrf } from '@app/enums/EExportarModeloCrf';

const CrfPlanilhaOrcadoEconomicoAnoMes = () => {
  const [planilhas, setPlanilhas] = useState(() => getAllCrfPlanilhasOrcadoEconomicoAnoMes);
  const [hasFile, setHasFile] = useState(false);
  const [atualizarTela, setAtualizarTela] = useState<boolean>(false);

  const validationSchema = Yup.object().shape({
    numero: Yup.number().required('O número é obrigatório.'),
    revisao: Yup.string().required('Revisão é obrigatória.'),
    dataAprovacao: Yup.date().required('Data de Aprovação é obrigatória.'),
  });

  useEffect(() => {
    const fetchData = () => {
      setPlanilhas(() => Promise.resolve(undefined));
      setPlanilhas(() => getAllCrfPlanilhasOrcadoEconomicoAnoMes);
    };

    fetchData();
  }, [atualizarTela]);

  const handleCreatePlanilhaOrcamento = (values: any) => {
    createCrfPlanilhaOrcamento(values, values.formData).then((result: any) => {
      if (result && result.valid) {
        setHasFile(true);
        setHasFile(false);
        setAtualizarTela(!atualizarTela);
        setPlanilhas(() => Promise.resolve(undefined));
        setPlanilhas(() => getAllCrfPlanilhasOrcadoEconomicoAnoMes);
        window.location.href = `/Cr/moduloOrcado/economicoAnoMes/detail/${result && result.id}`;
      }
    });
  };

  return (
    <CrudMasterDetailView
      getAllItems={planilhas}
      createItem={hasPermission(['ORCADO_ECONOMICO_ANUAL_EDITAR_ABA_INDEX']) ? Promise.resolve(undefined) : undefined}
      updateItem={hasPermission(['ORCADO_ECONOMICO_ANUAL_EDITAR_ABA_INDEX']) ? Promise.resolve(undefined) : undefined}
      disableNotification
      icon="business-estimate"
      detailTitleExtractor={x => `PLANILHA ORÇADO ECONÔMICO ANO MÊS ${x.numero}`}
      filterPredicate={(item, value) =>
        item.numero
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()) || (item.ano ? item.ano.toString().startsWith(value.toLowerCase()) : false)
      }
      titleExtractor={item => `Planilha ${item.numero}`}
      descriptionExtractor={item => `Rev: ${item.revisao} - ${item.ano}`}>
      <CrudContext.Consumer>
        {({ selectedItem }) => {

          return (
            <GridView noform>
              <MasterDetailForm
                validationSchema={validationSchema}
                onSubmit={values => {
                  handleCreatePlanilhaOrcamento(values, selectedItem);
                }}>
                <Widget
                  title="Dados da Planilha"
                  actions={[
                    <Button
                      type="link"
                      icon="files-xls"
                      onClick={() => {
                        exportaCrfModelo(EExportarModeloCrf.MODELO_IMPORTACAO_ANUAL);
                      }}>
                      Modelo de importação Anual
                    </Button>,
                    hasPermission(['ORCADO_ECONOMICO_ANUAL_EDITAR_ABA_INDEX']) && (
                      <Button
                        type="link"
                        icon="files-xls"
                        onClick={() => {
                          exportarCrfPlanilhaOrcadoEconomicoAnoMes(selectedItem.id, 'crfPlanilhaOrcadoEconomico.xlsx');
                        }}>
                        Exportar Planilha
                      </Button>
                    ),
                    hasPermission(['ORCADO_ECONOMICO_ANUAL_EDITAR_ABA_INDEX']) && (
                      <FormSubmitButton
                        type="primary"
                        onClick={values => {
                          if (selectedItem) values.id = selectedItem.id;

                          if (selectedItem) {
                            updateCrfPlanilhaOrcadoEconomicoAnoMes(values);
                          } else {
                            handleCreatePlanilhaOrcamento(values);
                          }
                        }}>
                        <FormatText id="ui.commons.save" uppercase />
                      </FormSubmitButton>
                    ),
                  ]}>
                  <FormNumber label="Número" name="numero" span={3} disabled={selectedItem} />
                  <FormInput label="Revisão" name="revisao" span={3} disabled={selectedItem} />
                  <FormDatePicker
                    label="Data de Aprovação"
                    name="dataAprovacao"
                    format="DD/MM/YYYY"
                    span={3}
                    required
                    disabled={selectedItem}
                  />
                  {selectedItem && <FormInput label="Status" name="statusPlanilha" disabled span={3} />}
                  <FormTextArea label="Observação" name="observacao" span={12} />
                  {!selectedItem && hasPermission(['ORCADO_ECONOMICO_ANUAL_EDITAR_ABA_INDEX']) && (
                    <UploadFile
                      hasFile={hasFile}
                      accept=".xlsx"
                      label="Incluir planilha"
                      id="importFilePlanilha"
                      selectedItem={selectedItem}
                    />
                  )}
                </Widget>
              </MasterDetailForm>
              {selectedItem ? (
                <CrfPlanilhaOrcadoEconomicoAnoMesTabela atualizarTelaProp={atualizarTela} planilhaId={selectedItem.id} />
              ) : (
                <> </>
              )}
            </GridView>
          );
        }}
      </CrudContext.Consumer>
    </CrudMasterDetailView>
  );
};

export default CrfPlanilhaOrcadoEconomicoAnoMes;
